function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Uses internal Who's on First data to do location autocomplete
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import { debounce, find, cloneDeep } from 'lodash';
import AutocompleteField from './AutocompleteFieldWithFallback';
import { addCheckToSuggestion } from '../utils/suggestions';
import { LOCATION_SUGGESTION_PROPTYPE, ONLINE_EVENTS_LOCATION_SLUG } from '../constants';
import './LocationAutocomplete.scss';
var LOCATION_DEBOUNCE_INTERVAL = 200;
var BBOX_SEARCH_DISPLAY_STRING = gettext('map area');

var LocationAutocompleteInternal =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(LocationAutocompleteInternal, _PureComponent);

  function LocationAutocompleteInternal(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_handleLocationAutocompleteSelect", function (selectedValue) {
      var _this$props = _this.props,
          suggestions = _this$props.locationSuggestions.suggestions,
          handleLocationSelect = _this$props.handleLocationSelect,
          handleUseCurrentLocation = _this$props.handleUseCurrentLocation,
          isUseCurrentLocationEnabled = _this$props.isUseCurrentLocationEnabled;
      var suggestedLocation = find(suggestions, function (_ref) {
        var value = _ref.value;
        return value === selectedValue;
      });
      _this._isItemSelected = true;
      /*
          Due to a bug relating to safari's usage of back-forward cache, the resting
          javascript is executed after clicking submit and the user clicks back via the
          back button. This causes _handleLocationAutocompleteSelect to then be called with null values,
          triggering a JS error making the field totaly uninteractable. So we need
          to check that suggestedLocation exists before running this.
      */

      if (suggestedLocation && suggestedLocation.value) {
        var value = suggestedLocation.value,
            slug = suggestedLocation.slug,
            currentPlace = suggestedLocation.currentPlace,
            currentPlaceParent = suggestedLocation.currentPlaceParent,
            latitude = suggestedLocation.latitude,
            longitude = suggestedLocation.longitude,
            placeType = suggestedLocation.placeType,
            _suggestedLocation$is = suggestedLocation.isOnline,
            isOnline = _suggestedLocation$is === void 0 ? false : _suggestedLocation$is;
        var placeId = suggestedLocation.placeId;
        placeId = placeId || value; // The online destination search endpoint needs the place id to be null

        if (slug === ONLINE_EVENTS_LOCATION_SLUG) {
          placeId = null;
        } // On selecting an item the autocomplete per a11y standards refocuses
        // the input. So we need to keep track of that in our own state controller.


        _this.setState({
          locationQuery: currentPlace,
          selectedLocation: currentPlace
        }, function () {
          handleLocationSelect({
            slug: slug,
            currentPlace: currentPlace,
            currentPlaceParent: currentPlaceParent,
            latitude: latitude,
            longitude: longitude,
            placeType: placeType,
            placeId: placeId,
            isOnline: isOnline
          });
          _this._isItemSelected = false;
        });
      } else if (isUseCurrentLocationEnabled) {
        _this._isItemSelected = false;

        _this.setState({
          locationQuery: '',
          selectedLocation: ''
        }, function () {
          handleUseCurrentLocation();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLocationAutocompleteChange", function (locationQuery) {
      _this.setState({
        locationQuery: locationQuery
      });

      _this._requestLocationSuggestions(locationQuery);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLocationAutocompleteBlur", function () {
      /*
      Previously we were able to assume the initial city was the previous selected one as each selection
      unmounted the component and triggered a new request. Now this is not the case. SO, we need to track
      in state when a selection has been made.
      */
      var selectedLocation = _this.state.selectedLocation;

      _this.setState({
        locationQuery: selectedLocation,
        isTyping: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLocationAutocompleteFocus", function () {
      /* The autocomplete will refocus on the input, triggering the handlefocus
      callback when an item is selected. We don't want to clear the input _after_
      a user selected an item but only when initially clicking. At the moment,
      selecting an item triggers a redirect so it will be reset each time. */
      if (!_this._isItemSelected) {
        _this.setState({
          locationQuery: '',
          isTyping: true
        }); //Setting the value state of the autcomplete component does not
        //trigger the onChange callback. So need to manually update the
        //location suggestions in this situation.


        _this._requestLocationSuggestions('');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_requestLocationSuggestions", debounce(function (locationQuery) {
      var handleLocationSuggestionChange = _this.props.handleLocationSuggestionChange;
      handleLocationSuggestionChange(locationQuery);
    }, LOCATION_DEBOUNCE_INTERVAL));

    var _currentPlace = props.currentPlace,
        isBBoxSearch = props.isBBoxSearch,
        _suggestions2 = props.locationSuggestions.suggestions;
    var _locationQuery = _currentPlace;

    if (isBBoxSearch) {
      _locationQuery = BBOX_SEARCH_DISPLAY_STRING;
    }

    _this.state = {
      locationQuery: _locationQuery,
      suggestions: _suggestions2,
      isTyping: false,
      selectedLocation: _currentPlace
    };
    return _this;
  }

  var _proto = LocationAutocompleteInternal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var onComponentDidMount = this.props.onComponentDidMount;

    if (onComponentDidMount) {
      onComponentDidMount();
    }

    this._isItemSelected = false;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
    var _this2 = this;

    var currentPlace = _ref2.currentPlace,
        isBBoxSearch = _ref2.isBBoxSearch,
        suggestions = _ref2.locationSuggestions.suggestions,
        isUseCurrentLocationEnabled = _ref2.isUseCurrentLocationEnabled;
    var newLocationQuery = currentPlace;

    if (isBBoxSearch) {
      newLocationQuery = BBOX_SEARCH_DISPLAY_STRING;
    }

    this.setState(function (_ref3) {
      var isTyping = _ref3.isTyping,
          currentLocationQuery = _ref3.locationQuery,
          currentSelectedLocation = _ref3.selectedLocation;
      var locationQuery = currentLocationQuery;
      var selectedLocation = currentSelectedLocation;
      var isUsingCurrentLocation = _this2.props.isUsingCurrentLocation;

      var _suggestions = cloneDeep(suggestions);

      if (isUseCurrentLocationEnabled && isUsingCurrentLocation) {
        _suggestions[0].content = addCheckToSuggestion({
          item: _suggestions[0],
          shouldShowCheck: isUsingCurrentLocation
        });
        _suggestions[0].secondaryContent = null;
      }

      if (!isTyping) {
        locationQuery = newLocationQuery;
        selectedLocation = newLocationQuery;
      }

      return {
        locationQuery: locationQuery,
        selectedLocation: selectedLocation,
        suggestions: _suggestions
      };
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var onComponentWillUnmount = this.props.onComponentWillUnmount;

    if (onComponentWillUnmount) {
      onComponentWillUnmount();
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        isWaitingForLocation = _this$props2.isWaitingForLocation,
        autocompleteProps = _this$props2.autocompleteProps,
        placeholder = _this$props2.placeholder;
    var _this$state = this.state,
        locationQuery = _this$state.locationQuery,
        selectedLocation = _this$state.selectedLocation,
        suggestions = _this$state.suggestions;
    var value = locationQuery;

    var _placeholder = placeholder || selectedLocation;

    if (isWaitingForLocation) {
      value = '';
      _placeholder = gettext('Finding your location...');
    }

    return React.createElement("div", {
      className: "location-autocomplete",
      "data-spec": "location-autocomplete"
    }, React.createElement(AutocompleteField, _extends({
      suggestions: suggestions,
      value: value,
      onBlur: this._handleLocationAutocompleteBlur,
      onChange: this._handleLocationAutocompleteChange,
      onFocus: this._handleLocationAutocompleteFocus,
      onSelect: this._handleLocationAutocompleteSelect,
      isV2: true,
      placeholder: _placeholder
    }, autocompleteProps)));
  };

  return LocationAutocompleteInternal;
}(PureComponent);

_defineProperty(LocationAutocompleteInternal, "propTypes", {
  currentPlace: PropTypes.string,
  locationSuggestions: LOCATION_SUGGESTION_PROPTYPE,
  placeId: PropTypes.string,
  placeholder: PropTypes.string,
  onComponentDidMount: PropTypes.func,
  onComponentWillUnmount: PropTypes.func,
  handleUseCurrentLocation: PropTypes.func,
  handleLocationSuggestionChange: PropTypes.func,
  handleLocationSelect: PropTypes.func,
  isBBoxSearch: PropTypes.bool,
  isUseCurrentLocationEnabled: PropTypes.bool,
  isOnlineEventsEnabled: PropTypes.bool,
  isOnline: PropTypes.bool,
  isWaitingForLocation: PropTypes.bool,
  isUsingCurrentLocation: PropTypes.bool,
  autocompleteProps: PropTypes.shape({
    borderType: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    hideOutline: PropTypes.bool,
    isLimitedSearch: PropTypes.bool,
    preventInputValuePrefill: PropTypes.bool
  })
});

_defineProperty(LocationAutocompleteInternal, "defaultProps", {
  autocompleteProps: {
    borderType: 'none',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true
  }
});

export { LocationAutocompleteInternal as default };